import React from 'react'

const SearchIcon = () => (
  <svg viewBox="0 0 25 25" fill="currentColor">
    <path d="M10 0C4.48867 0 0 4.48867 0 10C0 15.5113 4.48867 20 10 20C12.3967 20 14.5974 19.1489 16.3223 17.7363L22.293 23.707C22.3851 23.803 22.4955 23.8796 22.6176 23.9324C22.7397 23.9852 22.8712 24.0131 23.0042 24.0144C23.1373 24.0158 23.2692 23.9906 23.3924 23.9403C23.5156 23.89 23.6275 23.8157 23.7216 23.7216C23.8157 23.6275 23.89 23.5156 23.9403 23.3924C23.9906 23.2692 24.0158 23.1373 24.0144 23.0042C24.0131 22.8712 23.9852 22.7397 23.9324 22.6176C23.8796 22.4955 23.803 22.3851 23.707 22.293L17.7363 16.3223C19.1489 14.5974 20 12.3967 20 10C20 4.48867 15.5113 0 10 0ZM10 2C14.4307 2 18 5.56933 18 10C18 14.4307 14.4307 18 10 18C5.56933 18 2 14.4307 2 10C2 5.56933 5.56933 2 10 2Z" />
  </svg>
)

export default SearchIcon
